import {
  AccountDetailedInfo,
  EnvelopeQuery,
  GIBApplicationQuery,
  SetSignedContentResponse,
} from '../../models/ResponseModel'

export type InfoState = {
  accountDetailedInfo?: AccountDetailedInfo
  loadingAccountInfo: boolean
  loadingUserEnvelopeSign: boolean
  setSignedContentResponse?: SetSignedContentResponse
  envelopeQuery?: EnvelopeQuery
  gibApplicationQuery?: gibApplicationQueryState
  errorDescription?: string
}

export type gibApplicationQueryState = {
  isQuerying: boolean
  response?: GIBApplicationQuery
}

// export const initialState: InfoState = {
//   loadingAccountInfo: false,
//   loadingUserEnvelopeSign: false,
//   accountDetailedInfo: {
//     isExist: true,
//     isEInvoiceCustomer: false,
//     products: [
//       {
//         productType: ProductType.EINVOICE,
//         envelopeInfo: {
//           registerNumber: '41351160494',
//           name: 'ERDEM BAŞ',
//           gbAlias: 'urn:mail:defaultgb@nesbilgi.com.tr',
//           pkAlias: 'urn:mail:defaultpk@nesbilgi.com.tr',
//           envelopeNumber: '688e4bb2-a484-4d70-bc65-49d58199bee0',
//           envelopeType: EnvelopeType.ACTIVATION,
//           status: EnvelopeTransferStatus.NONE,
//           id: 12444,
//         },
//         status: ProductStatus.SEND,
//       },
//       {
//         productType: ProductType.EARCHIVE,
//         envelopeInfo: {
//           registerNumber: '41351160494',
//           name: 'ERDEM BAŞ',
//           gbAlias: '',
//           pkAlias: '',
//           envelopeNumber: '01a7bc3c-f01d-44be-b35c-ac8816c26643',
//           envelopeType: EnvelopeType.ACTIVATION,
//           status: EnvelopeTransferStatus.NONE,
//           id: 12445,
//         },
//         status: ProductStatus.SEND,
//       },
//       {
//         productType: ProductType.ESMM,
//         envelopeInfo: {
//           registerNumber: '41351160494',
//           name: 'ERDEM BAŞ',
//           gbAlias: '',
//           pkAlias: '',
//           envelopeNumber: '81a41d00-4e3c-4bee-bd5c-61377e376189',
//           envelopeType: EnvelopeType.ACTIVATION,
//           status: EnvelopeTransferStatus.NONE,
//           id: 12446,
//         },
//         status: ProductStatus.WAITCLIENTAPPROVE,
//       },
//     ],
//     useEBook: true,
//   },
// }

export const initialState: InfoState = {
  loadingAccountInfo: true,
  loadingUserEnvelopeSign: false,
  setSignedContentResponse: undefined,
  envelopeQuery: undefined,
  gibApplicationQuery: {
    isQuerying: false,
    response: undefined,
  },
}

export enum ActionTypes {
  ACCOUNT_INFO_REQUEST = '@@info/ACCOUNT_INFO_REQUEST_NOBLOCK',
  ACCOUNT_INFO_FULFILLED = '@@info/ACCOUNT_INFO_FULFILLED',
  ACCOUNT_INFO_REJECTED = '@@info/ACCOUNT_INFO_REJECTED',
  USER_ENVELOPE_PROCESS_REQUEST = '@@info/USER_ENVELOPE_PROCESS_REQUEST_NOBLOCK',
  USER_ENVELOPE_PROCESS_FULFILLED = '@@info/USER_ENVELOPE_PROCESS_FULFILLED',
  USER_ENVELOPE_PROCESS_REJECTED = '@@info/USER_ENVELOPE_PROCESS_REJECTED',
  CHANGE_SELECTED_PRODUCT = '@@info/CHANGE_SELECTED_PRODUCT',
  ENVELOPE_QUERY_REQUEST = 'ENVELOPE_QUERY_REQUEST_NOBLOCK',
  ENVELOPE_QUERY_FULFILLED = 'ENVELOPE_QUERY_FULFILLED',

  GIB_APPLICATION_QUERY_REQUEST = '@@info/GIB_APPLICATION_QUERY_REQUEST_NOBLOCK',
  GIB_APPLICATION_QUERY_FULFILLED = '@@info/GIB_APPLICATION_QUERY_FULFILLED',
}
